import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import carImg from 'images/tmp_car_image.png'

const CarDetail2 = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding center-cont">
					<div className="img-box" style={{ width: "21rem", height: "10rem" }}>
						<img src={carImg} alt="" />
					</div>
					<div className="car-info mt_20">
						<div>
							<span>테슬라</span>
							<span>테슬라 모델X</span>
						</div>
						<p>조대리님 미래 2058년의 차 테슬라 모델X</p>
					</div>
				</div>
			</div>

			<div className="padding">
				<ul className="tab-round">
					<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>출고옵션</li>
					<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>선택옵션</li>
				</ul>

				{/* 데이터 있을 때 */}
				<ul className="list-item mt_40">
					<li>
						<span>듀얼썬루프</span>
						<span>450,000 원</span>
					</li>
					<li>
						<span>자외선 차단</span>
						<span>450,000 원</span>
					</li>
					<li>
						<span>후방룸미러</span>
						<span>450,000 원</span>
					</li>
					<li>
						<span>안마시트</span>
						<span>450,000 원</span>
					</li>
					<li>
						<span>전방감지센서</span>
						<span>450,000 원</span>
					</li>
					<li>
						<span>공기청정기</span>
						<span>450,000 원</span>
					</li>
					<li>
						<span>자동주차보조시스템(ASPAS)</span>
						<span>450,000 원</span>
					</li>
					<li>
						<span>전동식 파워 트렁크</span>
						<span>450,000 원</span>
					</li>
					<li>
						<span>유아시트 고정(Isofix)</span>
						<span>450,000 원</span>
					</li>
				</ul>

				{/* 데이터 없을 때 */}
				<div className="center-cont py_80">
					<i className="icon icon_no_data" />
					<p className="mt_20">출고옵션 정보가 없어요.</p>
				</div>
			</div>
		</div>
	)
}

export default CarDetail2